<template>
  <super-admin-layout>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card flat>
            <v-card-actions>
              <v-text-field
                class="search-box"
                placeholder="Search Courses"
                prepend-icon="fa-search"
                v-model="search"
                type="text"
                clearable
                clear-icon="fa-times"
                @click:clear="resetSearch"
                @change="applySearch"
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-btn color="primary" outlined @click.prevent="showCreatePanel" class="mr-5">
                <v-icon class="mr-1" small>fa-plus</v-icon>Add Course
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card flat>
            <v-skeleton-loader v-if="loading && isTabletOrDesktop" type="table" :types="{ 'table-heading': '' }"></v-skeleton-loader>
            <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
            <v-data-table
              v-model="selected"
              :headers="headers"
              :options.sync="options"
              :server-items-length="serverItemsLength"
              v-show="!loading"
              :items="courses"
              item-key="id"
            >
              <template v-slot:item.name="{ item }" >
                <table-thumb :thumb="item"></table-thumb>
                <span class="ml-2">{{item.name}}</span>
              </template>
              <template v-slot:item.published="{ item }">
                <v-icon v-if="item.published" color="green" small>fa-check</v-icon>
                <v-icon v-else color="red" small>fa-times</v-icon>
              </template>
              <template v-slot:item.completion_progress="{ item }">
                <v-progress-linear height="20" color="blue" :value="item.completion_progress"></v-progress-linear>
              </template>
              <template v-slot:item.id="{ item }">
                <v-select
                  v-if="$vuetify.breakpoint.smAndDown"
                  v-model="selectedAction"
                  :items="getActionList(item)"
                  item-text="name"
                  item-value="id"
                  placeholder="Select Action"
                  @change="performAction(item)"
                ></v-select>
                <template v-else>
                  <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      class="mr-1 action-button action-button-txt"
                      small
                      outlined
                      @click.prevent="showCourseDetail(item.id)"
                    >
                      Details
                    </v-btn>
                  </template>
                  <span>Show Course Details</span>
                </v-tooltip>  
                <v-tooltip bottom v-if="!item.is_course_copied || item.is_course_copied">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      class="mr-1 action-button action-button-txt"
                      small
                      outlined
                      @click.prevent="showEditPanel(item.id)"
                    >
                      Edit
                    </v-btn>
                  </template>
                  <span>Edit Course</span>
                </v-tooltip>
                <v-tooltip bottom v-else>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      class="mr-1 action-button action-button-txt"
                      small
                      outlined
                      disabled
                    >
                      Edit
                    </v-btn>
                  </template>
                  <span>Edit Course</span>
                </v-tooltip>
                <v-tooltip bottom v-if="!item.is_course_copied || item.is_course_copied">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      :to="'/super-admin/partner/courses/'+item.id"
                      class="mr-1 action-button action-button-txt"
                      small
                      outlined
                    >
                      Content
                    </v-btn>
                  </template>
                  <span>Add & manage the course content</span>
                </v-tooltip>
                <v-tooltip bottom v-else>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      class="mr-1 action-button action-button-txt"
                      small
                      outlined
                      disabled
                    >
                      Content
                    </v-btn>
                  </template>
                  <span>Add & manage the course content</span>
                </v-tooltip>
                <v-tooltip bottom v-if="!item.is_course_copied || item.is_course_copied">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      @click.prevent="showEnrolPanel(item.id)"
                      class="mr-1 action-button action-button-txt"
                      small
                      outlined
                    >
                      Push Content(Customers)
                    </v-btn>
                  </template>
                  <span>Push Course Content</span>
                </v-tooltip>
                <v-tooltip bottom v-if="!item.is_course_copied || item.is_course_copied">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      @click.prevent="showEnrolPartnersPanel(item.id)"
                      class="mr-1 action-button action-button-txt"
                      small
                      outlined
                    >
                      Push Content(Partners)
                    </v-btn>
                  </template>
                  <span>Push Course Content</span>
                </v-tooltip>
                <v-tooltip bottom v-else>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      class="mr-1 action-button action-button-txt"
                      small
                      outlined
                      disabled
                    >
                      Push Content
                    </v-btn>
                  </template>
                  <span>Push Course Content</span>
                </v-tooltip>
                <template v-if="!item.is_course_copied || item.is_course_copied">
                    <v-tooltip v-if="item.hasOwnProperty('test')" bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                        v-on="on"
                        class="mr-1 action-button action-button-txt"
                        small
                        outlined
                        @click.prevent="editTest(item.test.data.id)"
                        width="83px"
                      >
                        Edit Test
                      </v-btn>
                      </template>
                      <span>Edit Test</span>
                    </v-tooltip>
                    <v-tooltip v-else bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          class="mr-1 action-button action-button-txt"
                          small
                          outlined
                          @click.prevent="createTest(item.id)"
                        >
                          Create Test
                        </v-btn>
                      </template>
                      <span>Create Test</span>
                    </v-tooltip>
                </template>
              </template>
                <!-- <template v-if="item.is_course_copied">
                    <v-tooltip v-if="item.hasOwnProperty('test')" bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          class="mr-1 action-button action-button-txt"
                          small
                          outlined
                          disabled
                          width="83px"
                        >
                          Edit Test
                        </v-btn>
                      </template>
                      <span>Edit Test</span>
                    </v-tooltip>
                    <v-tooltip v-else bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          class="mr-1 action-button action-button-txt"
                          small
                          outlined
                          disabled
                        >
                          Create Test
                        </v-btn>
                      </template>
                      <span>Create Test</span>
                    </v-tooltip>
                </template> -->
               <!-- <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      x-small
                      outlined
                      color="$improve-grey-900"
                      class="Frame-61"
                      @click.prevent="deleteCourse(item.id)"
                    >
                     <v-icon small>fa fa-trash</v-icon>
                    </v-btn>
                  </template>
                  <span>Delete this course and all User data for it</span>
                </v-tooltip>-->
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </super-admin-layout>
</template>

<script>
import { IMPROVE_CONFIG } from "@/config.js";
import { EventBus } from "@/event-bus.js";
import courseAPI from "@/api/course.js";
import testAPI from "@/api/test.js";
import SuperAdminLayout from "@/layouts/SuperAdmin";
import TableThumb from "@/components/partner/course/TableThumb";
import EditCourse from "@/components/partner/course/Edit";
import CreateCourse from "@/components/partner/course/Create";
import EnrolUsers from "@/components/partner/course/Enrol";
import ManageDeadlines from "@/components/partner/course/ManageDeadlines";
import RemoveUsers from "@/components/partner/course/RemoveUsers";
import CreateTest from "@/components/partner/course/AddTest";
import ShowCourseDetail from "@/components/partner/course/ShowCourseDetail";
import EnrolPartners from "@/components/partner/course/EnrolPartners";
export default {
  name: "CoursesPartner",
  components: {
    SuperAdminLayout,
    TableThumb
  },
  data() {
    return {
      headers: [
        { text: "Course", value: "name" },
        //{
        //  text: "Users",
        //  value: "total_enrolled_individual_users",
        //  sortable: false
        //},
        //{ text: "Groups", value: "total_groups", sortable: false },
        //{
        //  text: "Added Via Channel",
        //  value: "total_enrolled_via_channel_users",
        //  sortable: false
        //},
        /*{ text: "Total Users", value: "total_users", sortable: false },
        { text: "In Progress", value: "total_inprogress", sortable: false },
        { text: "Completed", value: "total_completed", sortable: false },
        { text: "Not Started", value: "total_not_started", sortable: false },*/
        //{
        //  text: "Completion Progress",
        //  value: "completion_progress",
        //  sortable: false
        //},
        { text: "", value: "id", sortable: false, align: "end" }
      ],
      courses: [],
      search: "",
      pagination: {},
      options: {},
      loading: false,
      searchParams: "",
      selected: [],
      confirmDelete:
        "Are you sure you want to delete this course?",
      publishNotification:"Selected course(s) can not be published, it seems you didn't add any video for this. Please upload at least one video to publish it.",
      selectedAction: null,
    };
  },
  computed: {
    serverItemsLength: function() {
      return this.pagination.total;
    },
    itemsPerPage: function() {
      return this.pagination.per_page;
    },
    page: function() {
      return this.pagination.current_page;
    },
    params: function() {
      return this.$gf.getQueryString(this.options, this.serverItemsLength);
    },
    hasTest: function() {
      return this.test == null ? false : true;
    },
    test: function() {
      return this.course.hasOwnProperty("test")
        ? this.course.test.data.id
        : null;
    },
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
  },
  watch: {
    options: {
      handler() {
        this.getCourses();
      },
      deep: true
    }
  },
  mounted() {
    this.setEventBus();
  },
  methods: {
    createTest(id) {
      testAPI.createTest(id).then(resp => {
        this.$router.push("/super-admin/partner/courses/test/" + resp.data.data.id);
      });
    },
    deleteCourse(id) {
      this.$snotify.confirm(this.confirmDelete, {
        backdrop:0.3,                         
        buttons: [
          { text: "Cancel",className: 'toast-cancel-button' },
          {
             text: "Continue",className: 'toast-continue-button',
             action: toast => this.processDeleteCourse(toast, id)
          }          
        ]
      });
    },
    processDeleteCourse(toast, id) {
      this.$snotify.remove(toast.id);
      courseAPI.deleteCourse(id).then(response => {
        this.getCourses();
      });
    },
    editTest(id) {
      this.$router.push("/super-admin/partner/courses/test/" + id);
    },
    publishCourses() {
      let selected = this.selected.map(function(x) {
        return x.id;
      });
      let totalVideos = this.selected.map(function(x) {
        return x.total_videos;
      });
      for(let i = 0; i <= totalVideos.length; i++){
        if(totalVideos[i]<=0) {
          this.$snotify.warning(this.publishNotification);
        } else {
          courseAPI.togglePublish(selected[i], true).then(resp => {
            this.getCourses();
          });
        }
      }
    },
    unpublishCourses() {
      let selected = this.selected.map(function(x) {
        return x.id;
      });
      courseAPI.togglePublish(selected, false).then(resp => {
        this.getCourses();
      });
    },
    applySearch() {
      this.options.page = 1;
      if (this.search != null) {
        this.searchParams =
          this.params +
          "&search=name:" +
          this.search +
          "&include=thumbnail,test";
      } else {
        this.searchParams = this.params + "&include=thumbnai,testl";
      }
      this.getCourses();
    },
    resetSearch() {
      this.options.page = 1;
      this.search = "&include=thumbnail,test";
      this.applySearch();
    },
    getCourses() {
      this.loading = true;
      courseAPI
        .getCourses(this.params + "&include=thumbnail,test", this.searchParams)
        .then(resp => {
          this.courses = resp.data.data;
          this.pagination = resp.data.meta.pagination;
          this.loading = false;
        });
    },
    setEventBus() {
      EventBus.$on("COURSES_UPDATED", payload => {
        this.params = payload;
        this.getCourses();
      });
    },
    showEditPanel(id) {
      this.$showPanel({
        component: EditCourse,
        props: {
          id: id,
          params: this.params
        },
        openOn: 'right',
      });
    },
    showCreateTestPanel(id) {
      this.$showPanel({
        component: CreateTest,
        props: {
          id: id
        },
        openOn: 'right',
      });
    },
    showCreatePanel() {
      this.$showPanel({
        component: CreateCourse,
        props: {
          params: this.params
        },
        openOn: 'right',
      });
    },
    showEnrolPanel(id) {
      this.$showPanel({
        component: EnrolUsers,
        disableBgClick: true,
        props: {
          id: id,
          params: this.params
        },
        openOn: 'right',
      });
    },
     showEnrolPartnersPanel(id) {
      this.$showPanel({
        component: EnrolPartners,
        disableBgClick: true,
        props: {
          id: id,
          params: this.params
        },
        openOn: 'right',
      });
    },
    showManageDeadlinesPanel(id) {
      this.$showPanel({
        component: ManageDeadlines,
        disableBgClick: true,
        props: {
          id: id,
          params: this.params
        },
        openOn: 'right',
      });
    },
    showRemoveUsersPanel(id) {
      this.$showPanel({
        component: RemoveUsers,
        disableBgClick: true,
        props: {
          id: id,
          params: this.params
        },
        openOn: 'right',
      });
    },
    /**
     * Show the course modal
     */
    showCourseDetail(id) {
      this.$showPanel({
        component: ShowCourseDetail,
        disableBgClick: true,
        props: {
          id: id,
          params: this.params
        },
        openOn: 'right',
      });
    },
    getActionList(item) {
      return [
        {
          name: 'Detail',
          action: () => this.showCourseDetail(item.id),
        },
        {
          name: 'Edit',
          action: () => this.showEditPanel(item.id),
        },
        {
          name: 'Content',
          action: () => this.$router.push(`/super-admin/partner/courses/${item.id}`),
        },
        {
          name: 'Push Content(Customers)',
          action: () => this.showEnrolPanel(item.id),
        },
        {
          name: 'Push Content(Partners)',
          action: () => this.showEnrolPartnersPanel(item.id),
        },
        {
          name: item.hasOwnProperty('test') ? 'Edit Test' : 'Create Test',
          action: () => {
            item.hasOwnProperty('test')
              ? this.editTest(item.test.data.id)
              : this.createTest(item.id);
          },
        },
      ];
    },
    performAction(item) {
      const selectedOption = this.getActionList(item).find(
        (option) => option.name === this.selectedAction
      );
      if (selectedOption) {
        selectedOption.action();
      }
      setTimeout(() => {
        this.selectedAction = null;
      }, 0);
    },
  }
};
</script>